import { config } from '../../../config/config';

/**
 * The Music24 help center on the website (music24-website `/help`). Built from the configured
 * website URL, so staging points at the staging site and local at the local website.
 */
export const HELP_CENTER_URL = `${config.smartLinksWebURL}help`;

/** One help article, at `/help/<category>/<article>` (slugs: music24-website `help/content/<category>/meta.ts`). */
export const helpArticleUrl = (category: string, article: string): string =>
  `${HELP_CENTER_URL}/${category}/${article}`;
